// 禁止登录
import React from 'react';
import intl from 'react-intl-universal';
import { getCdnHost } from '@/config/apiHosts';

import styles from './index.module.scss';

const Index = () => {
  return (
    <div className={styles.permissionDeniedForm}>
      <div className={styles.headerText}>{intl.get('login_permission_denied_title')}</div>
      <div>
        <img
          className={styles.permissionImage}
          src={`${getCdnHost()}/upload/prod/ypms/2024-05-06/UrnoiWJoZsmwh8oK9Xh.png`}
          alt="permission_denied"
        />
      </div>
      <div className={styles.footerText}>{intl.get('login_permission_denied_message')}</div>
    </div>
  );
};

export default Index;
